module.exports = __webpack_public_path__ + "img/circle-green.1e967e48.svg";